import { useMemo } from 'react';
import { AppType, useAppContext } from '@features/contexts/AppProvider';
import { STREAM_CHAT_MESSAGE_ACTIONS, StreamChatMessageAction } from '../../constants';

export function useStreamChatUserMenu(): StreamChatMessageAction[] {
  const { type } = useAppContext();

  return useMemo(() => {
    if (type === AppType.NopConnectPlatform) {
      return STREAM_CHAT_MESSAGE_ACTIONS;
    }

    return STREAM_CHAT_MESSAGE_ACTIONS.filter((action) => action !== StreamChatMessageAction.Mute);
  }, [type]);
}
